import CommonHeading from "../../../../Components/CommonHeading";
import Selector from "./Select";
import TableHead from "./TableHead";
import { useFormik } from "formik";
import * as Yup from "yup";
import Searchbar from "../../../../Components/Searchbar";
import { useCallback } from "react";
import DateSection from "./DateSection";
import InfoModule from "../../../../Components/InfoModule";
import { useDiscountsReportStore } from "../../../../Store/ReportsStore/DiscountsReportStore";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function Heading() {
  const {
    loadItems,
    updateParams,
    staffs_list,
    branches_list,
    queryParams,
    setLoading,
    discounts_count,
  } = useDiscountsReportStore();
  const { t } = useTranslation();

  const searchAction = useCallback(async (payload) => {
    updateParams({ search_query: payload.term, page: 1 });
    setLoading(true);
    await loadItems(
      new URLSearchParams({
        ...queryParams,
        page: 1,
        search_query: payload.term,
      }).toString()
    );
    setLoading(false);
  });

  const initialValues = {
    term: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      term: Yup.string().min(1, t("Qidiruvni kiriting!")),
    }),
    onSubmit: (values) => {
      searchAction({
        term: values.term,
      });
    },
  });

  const handleChange = (e) => {
    formik.setFieldValue("term", e.target.value);
    searchAction({
      term: e.target.value,
    });
  };

  const user = JSON.parse(localStorage.getItem("token"));

  const queryString = new URLSearchParams({
    ...queryParams,
    download: "excel",
    token: user.access || "",
  }).toString();

  const optionsBranch = useMemo(() => {
    return (
      branches_list?.map((element) => ({
        label: element.name,
        value: element.id,
      })) || []
    );
  }, [branches_list]);

  const optionsStaff = useMemo(() => {
    return (
      staffs_list?.map((element) => ({
        label: element.fullname,
        value: element.id,
      })) || []
    );
  }, [staffs_list]);

  return (
    <CommonHeading
      topItems={
        <>
          <Searchbar
            value={formik.values.term}
            handleChange={(e) => handleChange(e)}
            handleSubmit={formik.handleSubmit}
          />
          <Selector options={optionsStaff} property={t("O'qituvchilar")} />
          <Selector options={optionsBranch} property={t("Filiallar")} />
          <DateSection />
          <InfoModule title={discounts_count} />
        </>
      }
      tableHead={<TableHead />}
    />
  );
}
